/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponViewModel } from "../types/CouponViewModel.ts";
import { couponClassStudentItemViewModelSchema } from "./couponClassStudentItemViewModelSchema.ts";

export const couponViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do cupom.")),
  description: z.string().describe("Descrição do cupom.").nullish(),
  dateStart: z.optional(
    z.string().datetime().describe("Data de início da validade do cupom."),
  ),
  dateEnd: z.optional(
    z.string().datetime().describe("Data final da validade do cupom."),
  ),
  quantity: z
    .number()
    .int()
    .describe("Quantidade de utilizações permitidas do cupom. Opcional.")
    .nullish(),
  automatic: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o cupom é automático (gera vários códigos únicos) ou manual (um único código).",
      ),
  ),
  hash: z
    .string()
    .describe(
      "Código do cupom manual. Nulo quando o cupom é automático. Opcional.",
    )
    .nullish(),
  discountPercentage: z
    .number()
    .describe("Percentual de desconto aplicado. Valor entre 0 e 100. Opcional.")
    .nullish(),
  discountValue: z
    .number()
    .describe("Valor fixo de desconto aplicado. Opcional.")
    .nullish(),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa associada ao cupom. Opcional.")
    .nullish(),
  cumulative: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o desconto do cupom pode ser acumulado com outros descontos.",
      ),
  ),
  gift: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o cupom é uma cortesia (zera o valor da matrícula).",
      ),
  ),
  active: z.optional(z.boolean().describe("Indica se o cupom está ativo.")),
  classStudents: z
    .array(z.lazy(() => couponClassStudentItemViewModelSchema))
    .describe("Turmas vinculadas ao cupom.")
    .nullish(),
}) as unknown as ToZod<CouponViewModel>;
